import React, { useEffect } from 'react';
import './styles.scss';
import { RESOURCES } from './constants';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { resourcesRequested } from './actions';
import { getResources } from './selectors';

function Resources({ onLoad, resourcesProps }) {
    useEffect(() => {
        onLoad();
    }, []);

    const buttons = resourcesProps
        ? resourcesProps.data.map((element) => {
              RESOURCES.forEach((obj) => {
                  if (element.key === obj.key) {
                      element.text = obj.text;
                      element.image = obj.asset;
                  }
              });
              return (
                  <div
                      className="col-lg-4 col-md-6 col-xs-12 justify-content-center padding-y"
                      key={element.key}
                  >
                      <div className="box">
                          <a
                              className="box-inner"
                              href={element.value}
                              rel="noopener noreferrer"
                              target="_blank"
                          >
                              <div className="box-inner-image">
                                  <img src={element.image} />
                              </div>
                              <span>{element.text}</span>
                          </a>
                      </div>
                  </div>
              );
          })
        : null;

    return (
        <>
            <div className="segmentsHeader">
                <div className="row">
                    <h1 className="col-10 col-offset-1 space-between ">
                        Resources
                    </h1>
                </div>
            </div>
            <div className="row justify-content-center row-padding">
                {buttons}
            </div>
        </>
    );
}

Resources.propTypes = {
    onLoad: PropTypes.func,
    resourcesProps: PropTypes.obj,
};

const mapStateToProps = (state) => {
    return {
        resourcesProps: getResources(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => {
            dispatch(resourcesRequested());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Resources);
